var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "订单号", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.orderSn,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "orderSn", $$v)
              },
              expression: "listQuery.orderSn",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "请选择门店",
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.listQuery.storeId,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "storeId", $$v)
                },
                expression: "listQuery.storeId",
              },
            },
            _vm._l(_vm.shopList, function (item) {
              return _c("el-option", {
                key: item.storeId,
                attrs: { label: item.storeName, value: item.storeId },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "下单账号/手机号", clearable: "" },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "用户ID", clearable: "" },
            model: {
              value: _vm.listQuery.userId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "userId", $$v)
              },
              expression: "listQuery.userId",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "支付方式", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.payId,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "payId", $$v)
                },
                expression: "listQuery.payId",
              },
            },
            _vm._l(_vm.payTypeList, function (item) {
              return _c("el-option", {
                key: item.payId,
                attrs: { label: item.payName, value: item.payId },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "点餐场景", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.orderSaleType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "orderSaleType", $$v)
                },
                expression: "listQuery.orderSaleType",
              },
            },
            [
              _c("el-option", {
                key: "1",
                attrs: { label: "堂食", value: "1" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "2",
                attrs: { label: "自提", value: "2" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "3",
                attrs: { label: "外卖", value: "3" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "4",
                attrs: { label: "打包", value: "4" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "点餐类型", clearable: "", filterable: "" },
              model: {
                value: _vm.listQuery.groupType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "groupType", $$v)
                },
                expression: "listQuery.groupType",
              },
            },
            [
              _c("el-option", {
                key: "7",
                attrs: { label: "拼单", value: "7" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "8",
                attrs: { label: "拼桌", value: "8" },
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "9",
                attrs: { label: "团餐", value: "9" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "订单来源平台",
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.listQuery.platform,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "platform", $$v)
                },
                expression: "listQuery.platform",
              },
            },
            [
              _c("el-option", { attrs: { label: "微信", value: "wx" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "支付宝", value: "ali" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-date-picker", {
            staticStyle: { width: "360px" },
            attrs: {
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              format: "yyyy-MM-dd HH:mm:ss",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              clearable: "",
              "default-time": ["00:00:00", "23:59:59"],
            },
            on: { change: _vm.handleTimeRangeChange },
            model: {
              value: _vm.timeRange,
              callback: function ($$v) {
                _vm.timeRange = $$v
              },
              expression: "timeRange",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n        搜索\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.listQuery.activeName,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "activeName", $$v)
            },
            expression: "listQuery.activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部订单", name: "all" } }, [
            _vm._v("全部订单"),
          ]),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "待支付", name: "pendingPay" } },
            [_vm._v("待支付")]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "待分单", name: "pendingSplit" } },
            [_vm._v("待分单")]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "待发货", name: "pendingShip" } },
            [_vm._v("待发货")]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "确认收货", name: "confirmReceipt" } },
            [_vm._v("确认收货")]
          ),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已完结", name: "completed" } }, [
            _vm._v("已完结"),
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已取消", name: "canceled" } }, [
            _vm._v("已取消"),
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "已退款", name: "returned" } }, [
            _vm._v("已退款"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "订单号", align: "center", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(row.orderSn))]),
                    _vm._v(" "),
                    row.platform === "wx"
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              size: "mini",
                              type: "success",
                              effect: "light",
                            },
                          },
                          [_vm._v("微信")]
                        )
                      : row.platform === "ali"
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              size: "mini",
                              type: "primary",
                              effect: "light",
                            },
                          },
                          [_vm._v("支付宝")]
                        )
                      : row.platform
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              size: "mini",
                              type: "info",
                              effect: "light",
                            },
                          },
                          [_vm._v(_vm._s(row.platform))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    row.posOrderSn
                      ? _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v("(" + _vm._s(row.posOrderSn) + ")"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "下单时间",
              prop: "addTime",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.addTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.addTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "付款时间",
              prop: "payTime",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(row.payName))]),
                    _c("br"),
                    _vm._v(" "),
                    row.payTime
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("parseTime")(
                                row.payTime,
                                "{y}-{m}-{d} {h}:{i}:{s}"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "收货人", align: "center", "min-width": "350" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      row.orderSaleType == 3
                        ? _c("span", [
                            _vm._v(" " + _vm._s(row.consignee) + " "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !row.userId || !row.userRank
                        ? _c("span", [_vm._v("[ 游客订单 ]")])
                        : _c("span", [
                            _vm._v(
                              "[ TEL：" +
                                _vm._s(
                                  row.mobile || row.mobilePhone || "游客订单"
                                ) +
                                " ]"
                            ),
                          ]),
                      _c("br"),
                      _vm._v(" "),
                      row.orderSaleType == 1
                        ? _c("span", { staticStyle: { color: "blue" } }, [
                            _vm._v("堂食"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      row.orderSaleType == 2
                        ? _c("span", { staticStyle: { color: "orange" } }, [
                            _vm._v("自提"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      row.orderSaleType == 3
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("外卖"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      row.packageFlag
                        ? _c("span", { staticStyle: { color: "blue" } }, [
                            _vm._v("打包"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      row.groupType == 9
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "green",
                                "margin-left": "0.5em",
                              },
                            },
                            [_vm._v("团餐")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      row.groupType == 8
                        ? _c("span", { staticStyle: { color: "blue" } }, [
                            _vm._v("拼桌"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticStyle: { color: "blue", margin: "0 0.5em" } },
                        [_vm._v("(" + _vm._s(row.peopleNum) + ")")]
                      ),
                      _vm._v("\n            ["),
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(row.storeName) +
                            " " +
                            _vm._s(row.tableId)
                        ),
                      ]),
                      _vm._v("]"),
                      _c("br"),
                      _vm._v(" "),
                      row.orderSaleType == 3
                        ? _c("span", [
                            _vm._v(_vm._s(row.address)),
                            row.lat && row.lng
                              ? _c("span", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(row.lat) +
                                      "," +
                                      _vm._s(row.lng) +
                                      ")"
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "总金额",
              prop: "goodsAmount",
              align: "center",
              width: "115px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n            ￥" +
                        _vm._s(
                          (
                            Number(row.goodsAmount || 0) +
                            Number(row.shippingFee || 0) +
                            Number(row.packFee || 0) +
                            Number(row.wareFee || 0) +
                            Number(row.boxFee || 0)
                          ).toFixed(2)
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "交易额", align: "center", width: "115px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n          ￥" +
                        _vm._s(
                          row.orderAmount
                            ? Number(row.orderAmount).toFixed(2)
                            : "0.00"
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "应付金额", align: "center", width: "115px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n           ￥" +
                        _vm._s(
                          row.orderAmount
                            ? Number(row.orderAmount).toFixed(2)
                            : "0.00"
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "已付金额", width: "120px", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "余额：￥" +
                          _vm._s(
                            row.surplus
                              ? Number(row.surplus).toFixed(2)
                              : "0.00"
                          )
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "现金：￥" +
                          _vm._s(
                            row.moneyPaid
                              ? Number(row.moneyPaid).toFixed(2)
                              : "0.00"
                          )
                      ),
                    ]),
                    _c("br"),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发票", width: "100px", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.redPdfUrl
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownload(row)
                              },
                            },
                          },
                          [_vm._v("\n            已冲红\n          ")]
                        )
                      : row.pdfUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownload(row)
                              },
                            },
                          },
                          [_vm._v("\n            已开票\n          ")]
                        )
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单状态", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color: row.orderStatus === 2 ? "red" : "inherit",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._f("orderStatusFilter")(row.orderStatus))
                        ),
                      ]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("payStatusFilter")(row.payStatus))),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            (row.payStatus === 0 || row.payStatus === 1) &&
                            row.shippingStatus === 0
                              ? "lightgreen"
                              : row.shippingStatus === 3
                              ? "lightgreen"
                              : "inherit",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("shippingStatusFilter")(row.shippingStatus)
                          )
                        ),
                      ]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    row.returnStatus === 1
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("\n            已退货\n          "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "点餐数据", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.groupType == 7 ||
                    row.groupType == 8 ||
                    row.groupType == 9
                      ? _c(
                          "span",
                          {
                            staticClass: "dining-data-link",
                            on: {
                              click: function ($event) {
                                return _vm.handleShowDiningData(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            用户数：" +
                                _vm._s(row.peopleNum || 0) +
                                "人"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            下单用户：" +
                                _vm._s(row.orderUserCount || 0) +
                                "人"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            商品数：" +
                                _vm._s(row.goodsCount || 0) +
                                "件\n          "
                            ),
                          ]
                        )
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("--"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              "min-width": "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-top": "3px" },
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openEditInTab(row)
                              },
                            },
                          },
                          [_vm._v("\n              订单详情\n            ")]
                        ),
                        _vm._v(" "),
                        (row.payStatus === 0 || row.payStatus === 1) &&
                        (row.orderStatus === 1 || row.orderStatus === 2) &&
                        row.returnStatus === 0
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "3px" },
                                attrs: {
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-refresh",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCorrectStatus(row)
                                  },
                                },
                              },
                              [_vm._v("\n              修正状态\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.payStatus === 2 &&
                        row.shippingStatus === 0 &&
                        row.orderStatus !== 2 &&
                        row.orderStatus !== 4 &&
                        row.orderStatus !== 7 &&
                        row.returnStatus === 0 &&
                        !row.posOrderSn
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "3px" },
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  icon: "el-icon-s-promotion",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePushOrder(row)
                                  },
                                },
                              },
                              [_vm._v("\n              推送订单\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.payStatus === 2 &&
                        (row.shippingStatus === 1 ||
                          row.shippingStatus === 3 ||
                          row.shippingStatus === 4) &&
                        row.returnStatus === 0 &&
                        row.orderStatus != 7
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "3px" },
                                attrs: {
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-circle-check",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleConfirmReceive(row)
                                  },
                                },
                              },
                              [_vm._v("\n              确认收货\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.abnormalFlag === 1
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "3px" },
                                attrs: {
                                  size: "mini",
                                  type: "info",
                                  icon: "el-icon-document",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleShowAbnormalDetail(row)
                                  },
                                },
                              },
                              [_vm._v("\n              异常详情\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.abnormalFlag === 1
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "3px" },
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-circle-close",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEliminateException(row)
                                  },
                                },
                              },
                              [_vm._v("\n              消除异常\n            ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "abnormal-detail-dialog",
          attrs: {
            title: "异常订单详情",
            visible: _vm.abnormalDetailVisible,
            width: "80%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.abnormalDetailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "abnormal-dialog-content" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.abnormalDetailLoading,
                      expression: "abnormalDetailLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.abnormalDetailList,
                    stripe: "",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "订单号",
                      prop: "orderSn",
                      align: "center",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "日志名称",
                      prop: "name",
                      align: "center",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "日志类型",
                      prop: "type",
                      align: "center",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "错误信息",
                      prop: "message",
                      align: "center",
                      "min-width": "300",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "日志ID",
                      prop: "logId",
                      align: "center",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.abnormalDetailQuery.page,
                      "page-size": _vm.abnormalDetailQuery.limit,
                      "page-sizes": [10, 20, 50, 100],
                      total: _vm.abnormalDetailTotal,
                    },
                    on: {
                      "current-change": _vm.handleAbnormalDetailPageChange,
                      "size-change": _vm.handleAbnormalDetailSizeChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dining-data-dialog",
          attrs: {
            title: "点餐数据详情",
            visible: _vm.diningDataVisible,
            width: "70%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.diningDataVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.diningDataLoading,
                  expression: "diningDataLoading",
                },
              ],
              staticClass: "dining-dialog-content",
            },
            [
              _vm.diningData &&
              _vm.diningData.userDiningDetails &&
              _vm.diningData.userDiningDetails.length > 0
                ? _c(
                    "div",
                    [
                      _vm._l(
                        _vm.diningData.userDiningDetails,
                        function (userDetail, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "user-dining-section" },
                            [
                              _c(
                                "div",
                                { staticClass: "user-info-header" },
                                [
                                  _c(
                                    "el-avatar",
                                    {
                                      staticClass: "user-avatar",
                                      attrs: {
                                        src: userDetail.userPic || "",
                                        size: 50,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            userDetail.userAlias
                                              ? userDetail.userAlias.charAt(0)
                                              : "游"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "user-info-text" }, [
                                    _c("span", { staticClass: "user-name" }, [
                                      _vm._v(
                                        _vm._s(userDetail.userAlias || "游客")
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    userDetail.isGuest
                                      ? _c(
                                          "span",
                                          { staticClass: "user-tag" },
                                          [_vm._v("游客")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "goods-count-tag" },
                                      [
                                        _vm._v(
                                          "共" +
                                            _vm._s(userDetail.goodsCount) +
                                            "件商品"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "margin-top": "10px",
                                  },
                                  attrs: {
                                    data: userDetail.goodsList,
                                    stripe: "",
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName",
                                      align: "left",
                                      "min-width": "150",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "点餐用户",
                                      align: "center",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "goods-user-cell",
                                                },
                                                [
                                                  _c(
                                                    "el-avatar",
                                                    {
                                                      staticClass:
                                                        "goods-user-avatar",
                                                      attrs: {
                                                        src: row.userPic || "",
                                                        size: 32,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            row.userAlias
                                                              ? row.userAlias.charAt(
                                                                  0
                                                                )
                                                              : "游"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "数量",
                                      prop: "goodsNumber",
                                      align: "center",
                                      width: "80",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单位",
                                      prop: "unitName",
                                      align: "center",
                                      width: "80",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "会员价格",
                                      align: "center",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "price-text" },
                                                [
                                                  _vm._v(
                                                    "¥" +
                                                      _vm._s(
                                                        row.goodsPrice
                                                          ? Number(
                                                              row.goodsPrice
                                                            ).toFixed(2)
                                                          : "0.00"
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "游客价格",
                                      align: "center",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "price-text" },
                                                [
                                                  _vm._v(
                                                    "¥" +
                                                      _vm._s(
                                                        row.marketPrice
                                                          ? Number(
                                                              row.marketPrice
                                                            ).toFixed(2)
                                                          : "0.00"
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dining-footer" }, [
                        _c("span", [
                          _vm._v(
                            "共" +
                              _vm._s(_vm.diningData.totalGoodsCount || 0) +
                              "件商品"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "共" +
                              _vm._s(_vm.diningData.userDiningDetails.length) +
                              "位用户"
                          ),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _c("el-empty", { attrs: { description: "暂无点餐数据" } }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }